import { getItem, removeItem } from '../../helpers/storage';
import { useHistory } from 'react-router';
import { Analytics } from './../../common/utils/analytics';
import { clearFeatureFlags } from '../../helpers/featureFlags/featureFlags';

export const Logout = () => {
    Analytics.sendEventLogout();
    const history = useHistory();

    if (getItem('originalUser')) {
        removeItem('originalUser');
    }
    removeItem('lqaUser');
    removeItem('user');
    clearFeatureFlags();
    history.push('/');
    history.go(0);
    return null;
};
